"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEInstantGrouped = void 0;
var HistoryEInstantsGroupedList_1 = require("./HistoryEInstantsGroupedList");
// tslint:disable:variable-name
var HistoryEInstantGrouped = /** @class */ (function () {
    function HistoryEInstantGrouped(data) {
        this.gameId = data.gameId;
        this.gameName = data.gameName;
        this.gameAmount = data.gameAmount;
        this.transactionDate = data.transactionDate;
        this.gameImageUrl = data.gameImageUrl;
    }
    HistoryEInstantGrouped.JsonToEInstantsGrouped = function (data) {
        var einstantsList = new HistoryEInstantsGroupedList_1.HistoryEInstantsGroupedList();
        data.forEach(function (einstantGrouped) { return einstantsList.push(HistoryEInstantGrouped.JsonToEInstantGrouped(einstantGrouped)); });
        return einstantsList.getTransactionDateSorted();
    };
    HistoryEInstantGrouped.JsonToEInstantGrouped = function (data) { return new HistoryEInstantGrouped(data); };
    return HistoryEInstantGrouped;
}());
exports.HistoryEInstantGrouped = HistoryEInstantGrouped;
//# sourceMappingURL=HistoryEInstantGrouped.js.map